import { getGrowthBookConfigLoader } from '@doxyme/config';
import { getMembersInCall } from '../../features/realtime/realtime.selectors';
import { useAppSelector } from '../useReduxToolkit';
import { WaitingMember } from '../../shared/waitingMember';

export type UseCallStartPermissionReturn = {
  startCallDisabledReason?: 'parallelCallDisabled' | 'preCallTestRunning';
};

const isParallelCallDisabled = (): boolean =>
  getGrowthBookConfigLoader().getOptional(
    'feat_prod_162_disable_parallel_call',
  ) === true;

export const useCallStartPermission = (
  participant?: WaitingMember,
): UseCallStartPermissionReturn => {
  const inCall = useAppSelector(getMembersInCall).length > 0;

  if (isParallelCallDisabled() && inCall) {
    return {
      startCallDisabledReason: 'parallelCallDisabled',
    };
  }

  if (participant?.state?.['preCallTest']?.isRunning) {
    return {
      startCallDisabledReason: 'preCallTestRunning',
    };
  }

  return {
    startCallDisabledReason: undefined,
  };
};
